import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { format } from 'date-fns';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { formatISO } from '~/helpers/dateTime';
import {
  findData,
  deleteData,
  recordFiltering,
} from '~/store/modules/EdicaoOperacao/AlinhamentoTanque/actions';

import Form from './form';

export default function AlinhamentoTanque() {
  const redux = useSelector((state) => state.edicaoAlinhamentoTanque);

  const dateTime = useMemo(
    () => ({
      start: format(new Date(), 'dd/MM/yyyy 00:00:00'),
      end: format(new Date(), 'dd/MM/yyyy 23:59:59'),
    }),
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'datahorainicioalinhamentotanquefisico',
        label: t('s.operacao.transferencia.datahorainicialmovimentacao'),
        formatted: (date) => formatISO({ date }),
        filter: {
          type: 'initialdatetime',
          defaultValue: dateTime.start,
        },
      },
      {
        id: 'datahorafimalinhamentotanquefisico',
        label: t('s.operacao.transferencia.datahorafinalmovimentacao'),
        formatted: (date) => formatISO({ date }),
        filter: {
          type: 'finaldatetime',
          defaultValue: dateTime.end,
        },
      },
      {
        id: 'idposto',
        label: t('s.configuracao.posto.idposto'),
        filter: {
          type: 'number',
        },
      },
      {
        id: 'codigonomeposto',
        label: t('s.relatorio.geral.unidade'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'idtanquevirtual',
        label: t('s.menu.configuracao.tanquevirtual'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'codigotanquefisicoanterior',
        label: t('s.camposistema.codigotanquefisicoanterior'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'codigotanquefisiconovo',
        label: t('s.camposistema.codigotanquefisiconovo'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'codigousuario',
        label: t('s.menu.cadastro.usuario'),
      },
    ],
    [dateTime]
  );

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findData}
      remove={deleteData}
      form={Form}
      detach="nomeposto"
      keys={['idalinhamentotanquefisico', 'idposto', 'idtanquefisicoanterior']}
    />
  );
}
